export default __webpack_public_path__ + "static/media/new-1.d4c322f0.png";